import React from 'react';
import {useDispatch} from 'react-redux';

import * as localizationKeys from '../../../consts/localization/localizationKeys';
import networkStatusService from '../../../services/networkStatusService';
import {setNotificationInfo} from '../../../state/ducks/global';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import helpers from '../../../utils/helpers';
import {IButton} from '../ButtonTypes';

interface IProps extends IButton {
    button: React.FC<any>;
    ariaLabelLastSlide?: string;
    customClassName?: string;
    isTabletShowArrows?: boolean;
}

const ConnectionTrackButton: React.FC<IProps> = (props) => {
    const {button: Button, onClick, ...restProps} = props;
    const dispatch = useDispatch();
    const onClickOffline = () => {
        dispatch(
            setNotificationInfo({
                textKey: localizationKeys.NO_INTERNET_CONNECTION_SCENARIO_2_NOTIFICATION_TEXT,
                testId: elementsTesIds.ABOUT_MY_DEVICE_OFFLINE_NOTIFICATION,
            } as any)
        );
    };

    return (
        <Button
            className='mx-auto'
            {...restProps}
            onClick={(e: React.MouseEvent<HTMLElement>) =>
                networkStatusService.isOnline() ? helpers.runFunction(onClick, e) : onClickOffline()
            }
        />
    );
};

export default ConnectionTrackButton;
